import { render, staticRenderFns } from "./UserAccounts.vue?vue&type=template&id=9fab3c94&scoped=true&"
import script from "./UserAccounts.vue?vue&type=script&lang=ts&"
export * from "./UserAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccounts.vue?vue&type=style&index=0&id=9fab3c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fab3c94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VContainer,VLayout,VRow,VSimpleTable})
